import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class Stopper extends React.Component {
  constructor(props){

    super(props)

    const interactions = (heldObj, target) => {
      //Don't run if this stopper not the held object
      if(heldObj.type !== "Stopper" || heldObj.id !== this.props.id){
        return null;
      }
      if (target === undefined || target === null) {
        return null;
      }
      if (target.type === "GlassTube") {
        //Get the targeted GlassTube
        const tubeID = target.id
        const targetGlassTube = this.props.interactionProps.glassTubes[tubeID - 1]

        if(targetGlassTube.stopperId !== -1) {
          //this.makeToast("WARNING", "This cuvette already contains a lid.", "Cuvette contains lid!");
          return null;
        }

        this.props.onDropStopper({
          stopperId: this.props.id,
          tubeID: targetGlassTube.id,
          type: 'stopper'
        })

        this.props.setStoppersInScene({
          id: this.props.id,
          inScene: false
        });

        // Reset the tube position to a zero transform
        heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"

        // if(targetGlassTube.open) {
        //   targetGlassTube.onDropItem(this.props.id);

        // } else {
        //   this.makeToast("WARNING", "You must open the glass tube first.", "Glass Tube is closed!")
        // }
      } else {
        return null
      }
    }
    Object.defineProperty(interactions, 'name', {value: ('stopper_interactions_'+this.props.id), configurable: true});
    this.props.pushInteractions([interactions])
  }



  componentWillMount() {
    this.props.createStopper({
      props: this.props.defaultProps,
    });
  }
  stopperSelected = (e) => {

    this.props.setStopperHeld({
      id: this.props.id,
      held: true,
    })
    this.props.setHeldObject({
      id: this.props.id,
      type: "Stopper",
      htmlObj: e.target,
    });
    if(!this.props.controlsVisible){
      this.showControls()
  }
  }

  stopperUnselected = (e) => {
    this.props.setStopperHeld({
      id: this.props.id,
      held: false,
    })
  }

  showControls = ()=> {
    this.props.hideAllControls();
    this.props.setStopperControlVisibility({id: this.props.id, controlsVisible: true});
  }
  render() {
    return (
      <ul style={{
        visibility: !this.props.inScene ? "hidden" : null,
        zIndex: this.props.controlsVisible ? 99 : null,
      }}>
        <li
          id={"Stopper_"+this.props.id}
          className={'Stopper draggable'}
          onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.stopperSelected() } }
          onDragStart={(e) => this.stopperSelected(e)}
          onDragEnd={(e) => this.stopperUnselected(e)}
          draggable
          tabIndex={0}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

Stopper.propTypes = {
  createStopper: PropTypes.func,
};

Stopper.defaultProps = {};
